import { Link } from "react-router-dom";
import {
    CoinsIcon,
    InfinityIcon,
    SignOutIcon,
    SparkleIcon,
} from "@phosphor-icons/react";
import { useAuth } from "@/lib/auth";

function formatUntil(iso) {
    if (!iso) return "";
    try {
        const d = new Date(iso);
        return d.toLocaleDateString("zh-CN", {
            month: "numeric",
            day: "numeric",
        });
    } catch (_) {
        return "";
    }
}

export default function Header() {
    const { user, logout } = useAuth();
    const unlimited = !!user?.is_unlimited;

    return (
        <header
            className="sticky top-0 z-50 backdrop-blur-xl bg-[#0A0A0C]/80 border-b border-white/5"
            data-testid="app-header"
        >
            <div className="max-w-3xl mx-auto px-5 sm:px-8 h-14 flex items-center justify-between">
                <Link
                    to="/"
                    className="flex items-center gap-2 group"
                    data-testid="home-link"
                >
                    <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-white text-black">
                        <SparkleIcon
                            size={15}
                            weight="fill"
                            aria-hidden="true"
                        />
                    </span>
                    <span className="font-cn font-bold tracking-tight text-base">
                        男人照变帅
                    </span>
                </Link>
                {user ? (
                    <div className="flex items-center gap-2">
                        {unlimited ? (
                            <span
                                className="inline-flex items-center gap-1.5 text-xs font-semibold bg-white text-black rounded-full px-2.5 py-1"
                                data-testid="unlimited-badge"
                                title={
                                    user.unlimited_until
                                        ? `至 ${formatUntil(user.unlimited_until)}`
                                        : ""
                                }
                            >
                                <InfinityIcon size={12} weight="bold" />
                                无限
                                {user.unlimited_until ? (
                                    <span className="text-black/50">
                                        · 至 {formatUntil(user.unlimited_until)}
                                    </span>
                                ) : null}
                            </span>
                        ) : (
                            <span
                                className="inline-flex items-center gap-1.5 text-xs text-white/80 bg-white/[0.05] border border-white/10 rounded-full px-2.5 py-1"
                                data-testid="credit-counter"
                            >
                                <CoinsIcon size={12} weight="fill" />
                                <span className="tabular-nums">
                                    {user.credits}
                                </span>
                                <span className="text-white/40">张</span>
                            </span>
                        )}
                        <button
                            type="button"
                            onClick={logout}
                            data-testid="logout-button"
                            className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-white/[0.04] border border-white/10 text-white/70 hover:text-white hover:bg-white/[0.08] transition-colors"
                            title="退出"
                        >
                            <SignOutIcon size={13} weight="bold" />
                        </button>
                    </div>
                ) : null}
            </div>
        </header>
    );
}
